import React, { useCallback } from 'react';
import { ActivityType, Box, CategoryIcon, SortOption, Text } from '@common-fe/common-fe';

import { ServicesPaymentOrder } from '@/modules/UseMyMoney/components';
import { GroupServicesKey, OcrAccountOrderOption } from '@/modules/UseMyMoney/UseMyMoney.types';

export interface GroupTitleRenderWrapperProps {
  groupKey?: string;
  title?: string;
  activeSort?: SortOption;
}

interface Props {
  servicesGrouping: GroupServicesKey;
  accountOrdersArraysWithUniqServices?: OcrAccountOrderOption[][];
  isMobile?: boolean;
}

const useServiceCategoryRenderWrapper = ({ servicesGrouping, accountOrdersArraysWithUniqServices, isMobile }: Props) => {
  const serviceCategoryRenderWrapper = useCallback(({ title, groupKey }: GroupTitleRenderWrapperProps) => {
    if (servicesGrouping === GroupServicesKey.ACCOUNT) {
      const servicesAccountOrders = accountOrdersArraysWithUniqServices?.find((accountOrders) => accountOrders?.[0]?.index === groupKey);
      return (
        <ServicesPaymentOrder
          accountOrders={servicesAccountOrders}
          isMobile={isMobile}
        />
      );
    }

    return (
      <Box
        data-testId="service_dropdown-input_category-header"
        margin={{ bottom: 'spacing2' }}
        direction="row"
        align="center"
      >
        <CategoryIcon
          data-testId="service_dropdown-input_category-header_icon"
          category={title?.toLocaleUpperCase() as ActivityType}
          customSize="16px"
          color="iconPrimary"
          width="16px"
          height="16px"
          isColorFullMode
        />
        <Text
          data-testId="service_dropdown-input_category-header_title"
          size="small"
          weight={500}
          margin={{ left: 'spacing4' }}
        >
          {title}
        </Text>
      </Box>
    );
  }, [servicesGrouping, accountOrdersArraysWithUniqServices, isMobile]);

  return {
    serviceCategoryRenderWrapper,
  };
};

export default useServiceCategoryRenderWrapper;
